import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form, Card } from 'react-bootstrap';
import * as Icon from 'react-feather';

function DefaultModal(props) {
    const apiUrl = process.env.REACT_APP_URL;
    const authHeader = useAuthHeader();

    const [cleaningData, setCleaningData] = useState({
        inventory_id: '',
        service_date: '',
        service_time: '',
        responsible_user_id: '',
        supervisor_user_id: '',
        total_cost: 0,
        is_completed: false,
        notes: ''
    });

    const [loading, setLoading] = useState(false);

    // Initialize form with cleaning data when modal opens
    useEffect(() => {
        if (props.show && props.cleaningInfo) {
            initializeForm();
        }
    }, [props.show, props.cleaningInfo]);

    const initializeForm = () => {
        const cleaning = props.cleaningInfo;

        // Split service datetime into date and time
        const serviceDateTime = cleaning.service_datetime ? cleaning.service_datetime.split(' ') : ['', ''];
        const serviceDatePart = serviceDateTime[0] || '';
        const serviceTimePart = serviceDateTime[1] ? serviceDateTime[1].slice(0, 5) : ''; // Remove seconds

        setCleaningData({
            inventory_id: cleaning.inventory_id || '',
            service_date: serviceDatePart,
            service_time: serviceTimePart,
            responsible_user_id: cleaning.responsible_user_id || '',
            supervisor_user_id: cleaning.supervisor_user_id || '',
            total_cost: cleaning.total_cost || 0,
            is_completed: cleaning.is_completed || false,
            notes: cleaning.notes || ''
        });
    };

    const handleChange = (field, value) => {
        setCleaningData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        try {
            // Combine date and time for service_datetime
            const service_datetime = `${cleaningData.service_date} ${cleaningData.service_time}:00`;

            const payload = {
                inventory_id: cleaningData.inventory_id,
                service_datetime: service_datetime,
                responsible_user_id: cleaningData.responsible_user_id,
                supervisor_user_id: cleaningData.supervisor_user_id || null,
                total_cost: parseFloat(cleaningData.total_cost) || 0,
                is_completed: cleaningData.is_completed,
                notes: cleaningData.notes || null
            };

            const response = await axios.put(`${apiUrl}/services/cleaning/${props.cleaningInfo.id}`, payload, {
                headers: {
                    Authorization: authHeader()
                }
            });

            alert('Limpieza actualizada exitosamente');
            props.setData();
            props.onHide();

        } catch (error) {
            console.error('Error updating cleaning:', error);
            alert('Error al actualizar el registro de limpieza');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar Limpieza
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <Container>
                    <Form onSubmit={handleSubmit}>
                        {/* Basic Information */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Información Básica</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Unidad *</Form.Label>
                                        <Form.Select
                                            value={cleaningData.inventory_id}
                                            onChange={(e) => handleChange('inventory_id', e.target.value)}
                                            required
                                        >
                                            <option value="">Seleccionar unidad...</option>
                                            {props.inventoryOptions.map((unit) => (
                                                <option key={unit.id} value={unit.id}>
                                                    {unit.name || unit.inventory_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} md={6}>
                                        <Form.Check
                                            type="checkbox"
                                            label="Completado"
                                            checked={cleaningData.is_completed}
                                            onChange={(e) => handleChange('is_completed', e.target.checked)}
                                            className="mt-4"
                                        />
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Fecha del Servicio *</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={cleaningData.service_date}
                                            onChange={(e) => handleChange('service_date', e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Hora del Servicio</Form.Label>
                                        <Form.Control
                                            type="time"
                                            value={cleaningData.service_time}
                                            onChange={(e) => handleChange('service_time', e.target.value)}
                                        />
                                    </Form.Group>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Staff Assignment */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Asignación de Personal</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Responsable *</Form.Label>
                                        <Form.Select
                                            value={cleaningData.responsible_user_id}
                                            onChange={(e) => handleChange('responsible_user_id', e.target.value)}
                                            required
                                        >
                                            <option value="">Seleccionar responsable...</option>
                                            {props.userOptions.map((user) => (
                                                <option key={user.id} value={user.id}>
                                                    {user.full_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Supervisor</Form.Label>
                                        <Form.Select
                                            value={cleaningData.supervisor_user_id}
                                            onChange={(e) => handleChange('supervisor_user_id', e.target.value)}
                                        >
                                            <option value="">Seleccionar supervisor...</option>
                                            {props.userOptions.map((user) => (
                                                <option key={user.id} value={user.id}>
                                                    {user.full_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Cost Information */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Información de Costos</h6>
                            </Card.Header>
                            <Card.Body>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md={6}>
                                        <Form.Label>Costo Total</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            value={cleaningData.total_cost}
                                            onChange={(e) => handleChange('total_cost', e.target.value)}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Additional Notes */}
                        <Card className="mb-3">
                            <Card.Header>
                                <h6 className="mb-0">Notas Adicionales</h6>
                            </Card.Header>
                            <Card.Body>
                                <Form.Group>
                                    <Form.Label>Notas</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={cleaningData.notes}
                                        onChange={(e) => handleChange('notes', e.target.value)}
                                        placeholder="Cualquier información adicional relevante..."
                                    />
                                </Form.Group>
                            </Card.Body>
                        </Card>

                        <div className="text-end">
                            <Button variant="secondary" onClick={props.onHide} className="me-2">
                                Cancelar
                            </Button>
                            <Button type="submit" variant="primary" disabled={loading}>
                                {loading ? 'Actualizando...' : 'Actualizar Limpieza'}
                            </Button>
                        </div>
                    </Form>
                </Container>
            </Modal.Body>
        </Modal>
    );
}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let edit_cleaning = () => {
            this.props.setData();
            this.setState({ modalShow: false });
        }

        return (
            <ButtonToolbar>
                <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    <Icon.Edit size={14} />
                </Button>
                <DefaultModal
                    show={this.state.modalShow}
                    onHide={edit_cleaning}
                    setData={this.props.setData}
                    cleaningInfo={this.props.cleaningInfo}
                    inventoryOptions={this.props.inventoryOptions}
                    userOptions={this.props.userOptions}
                />
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
